import { registerFeatureWithDescription } from "lib/features"
import { MOBILISER_ADVANCED_MAPPING_FEATURE } from "routes/asset-register/plugins/asset-mapping/mobiliser-advanced-mapping-feature.mjs"

export const FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING = registerFeatureWithDescription({
    numericalId: 2.5,
    id: MOBILISER_ADVANCED_MAPPING_FEATURE,
    name: "Mobiliser advanced mapping and type review",
    internalUseOnly: true,
    descriptionLines: [
        "Step-by-step mapping settings wizard, type processing progress, AI type review, status chip and schedule library preference.",
        "Off: the register uses the previous inline settings card and goes straight to schedule mapping.",
    ],
})
